import React from '../../_snowpack/pkg/react.js';

function Scale({
  height,
  width
}) {
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.518 5.093c0-.149.09-.284.227-.341l2.223-.934a.37.37 0 01.513.342v14.628a.37.37 0 01-.37.37H8.889a.37.37 0 01-.37-.37V5.093z",
    fill: "#DAF5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.252.02a.37.37 0 01.471.229l.65 1.865a.37.37 0 01-.228.472l-12.12 4.22a.37.37 0 01-.472-.228l-.65-1.865a.37.37 0 01.228-.472l12.12-4.22z",
    fill: "#DAF5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.407 14.105c0 1.973-1.658 3.572-3.703 3.572-2.046 0-3.704-1.6-3.704-3.572s3.704-7.54 3.704-7.54 3.703 5.568 3.703 7.54z",
    fill: "#DAF5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.667 13.232l-2.963.37-2.963-.37 2.963-5.555 2.963 5.555z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.517 13.73c-.431-.16-.8-.369-1.038-.606l.524-.524c.133.133.393.295.772.436.372.138.835.247 1.349.29 1.03.087 2.242-.088 3.347-.778l.392.628c-1.266.791-2.646.986-3.802.888a5.921 5.921 0 01-1.544-.334z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.031c0 1.973-1.658 3.572-3.703 3.572-2.046 0-3.704-1.6-3.704-3.572s3.704-7.54 3.704-7.54S20 8.06 20 10.032z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26 5.34v13.077h1.48v-13.7l-1.48.622zm-.515-.588a.37.37 0 00-.226.341v13.695c0 .204.165.37.37.37h2.222a.37.37 0 00.37-.37V4.16a.37.37 0 00-.513-.342l-2.223.934z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.145.842L3.725 4.819l.405 1.166 11.421-3.977-.406-1.166zm.578-.593a.37.37 0 00-.471-.228L3.132 4.24a.37.37 0 00-.229.472l.65 1.865a.37.37 0 00.471.228l12.12-4.22a.37.37 0 00.229-.472l-.65-1.865z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.704 16.936c1.662 0 2.963-1.293 2.963-2.83 0-.325-.17-.917-.518-1.716a27.154 27.154 0 00-1.238-2.43 53.46 53.46 0 00-1.207-2.022A53.46 53.46 0 002.497 9.96a27.154 27.154 0 00-1.239 2.43c-.347.8-.517 1.391-.517 1.715 0 1.538 1.3 2.83 2.963 2.83zm-.44-9.69C2.283 8.793 0 12.556 0 14.106c0 1.972 1.658 3.57 3.704 3.57 2.045 0 3.703-1.598 3.703-3.57 0-1.55-2.282-5.313-3.263-6.86-.27-.423-.44-.68-.44-.68s-.171.257-.44.68zM16.296 12.862c1.662 0 2.963-1.293 2.963-2.83 0-.325-.17-.917-.517-1.716a27.143 27.143 0 00-1.239-2.43 53.523 53.523 0 00-1.207-2.022 53.523 53.523 0 00-1.207 2.022 27.143 27.143 0 00-1.238 2.43c-.348.8-.518 1.391-.518 1.715 0 1.538 1.301 2.83 2.963 2.83zm-.44-9.69c-.98 1.547-3.263 5.31-3.263 6.86 0 1.972 1.658 3.57 3.703 3.57 2.046 0 3.704-1.598 3.704-3.57 0-1.55-2.282-5.313-3.264-6.86-.269-.423-.44-.68-.44-.68s-.17.257-.44.68z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 10.64l2.963.617 2.963-.617s-.37 2.222-2.963 2.222c-2.592 0-2.963-2.222-2.963-2.222z",
    fill: "#DAF5CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.88 11.076c-.475-.135-.881-.311-1.143-.513l.452-.587c.154.119.457.263.894.388.428.123.96.219 1.55.257 1.183.078 2.574-.078 3.836-.685l.321.667c-1.405.676-2.93.84-4.205.758a8.249 8.249 0 01-1.706-.285z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26 3.603h1.48v3.703H9.26V3.603z",
    fill: "#DAF5CB"
  }));
}

Scale.defaultProps = {
  height: 20,
  width: 20
};
export default Scale;